export default "__VITE_ASSET__4d915574__"